module.exports = __webpack_public_path__ + "public/images/Collage—Girl3.c8a4067bcacfcbd83d0f536ebae1d880.png";